export default __webpack_public_path__ + "static/media/map-arrow.32ea0983.svg";